<div class="card-dashboard d-flex align-items-center p-4 my-0">
    <div class="pe-2">
        <strong>
            <p *ngIf="order.NE__Cart_Description__c">{{order.NE__Cart_Description__c}}</p>
        </strong>
        <p *ngIf="order.NE__Cart_Description__c">
            {{this.descLabel.translation}}
        </p>
    </div>
    <!-- <div class="ms-auto">
        <img src="./assets/icons/logo_card.svg">
    </div> -->
</div>
<div class="mt-4" *ngIf="order?.option_items?.length">
    <div ngbAccordion>
        <div ngbAccordionItem id="contract-options">
            <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                    <span class="ms-2" [innerHTML]="'documents-included-accessories' | translate"></span>
                </button>
            </h2>
            <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                    <ng-template>
                        <ng-container *ngFor="let option of order?.option_items; let i = index">
                            <p *ngIf="option" class="mb-0 fs-20 fw-bold">{{'service-option-title-' + option.NE__Engine_Code__c  | translate}}</p>
                            <p *ngIf="option" class="{{i >= (order?.option_items.length - 1) ? 'mb-0' : 'mb-3'}}">{{'service-option-description-' + option.NE__Engine_Code__c  | translate}}</p>
                        </ng-container>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="py-2">
    <hr class="w-50 mx-auto my-4" />
</div>
<form [formGroup]="contractSelectionForm" onkeypress="return event.keyCode != 13;">
    <mat-radio-group formControlName="contract_duration" placeholder="Contract" attr.aria-label="{{'common-select-option' | translate}}" class="d-flex flex-column" [(ngModel)]="this.request.contract_duration">
        <ng-container *ngFor="let duration of durations.orders; let i=index">
            <mat-radio-button class="rounded-box mb-2 {{i === 0 ? 'mt-0' : 'mt-1'}}" [value]="duration" [checked]="durations.orders.length === 1" [disabled]="waitSave">
                <div *ngIf="duration.duration === 1" class="d-flex flex-row align-items-center justify-content-between">
                    <p class="mb-0">{{ duration.duration }} {{"durations-month-text" | translate}} <strong>{{duration.updatedPrice}} </strong></p>
                    <p *ngIf="duration.discount" class="mb-0 help-cta text-end" [class.opacity-75]="waitSave" [innerHTML]="duration.updatedDiscount"></p>
                </div>
                <div *ngIf="duration.duration > 1 && duration.rest !== 0" class="d-flex flex-row align-items-center justify-content-between">
                    <p class="mb-0">{{ duration.duration }} {{"durations-months-text" | translate}} <strong>{{duration.updatedPrice}} </strong></p>
                    <p *ngIf="duration.discount" class="mb-0 help-cta text-end" [class.opacity-75]="waitSave" [innerHTML]="duration.updatedDiscount"></p>
                </div>
                <div *ngIf="duration.duration === 12 && duration.rest === 0 && years && years.length" class="d-flex flex-row align-items-center justify-content-between">
                    <p class="mb-0">{{ duration.duration  | monthsToYears }} {{years[0]}} <strong>{{duration.updatedPrice}} </strong></p>
                    <p *ngIf="duration.discount" class="mb-0 help-cta text-end" [class.opacity-75]="waitSave" [innerHTML]="duration.updatedDiscount"></p>
                </div>
                <div *ngIf="duration.duration > 12 && duration.rest === 0 && years && years.length" class="d-flex flex-row align-items-center justify-content-between">
                    <p class="mb-0">{{ duration.duration | monthsToYears }} {{years[1]}} <strong>{{duration.updatedPrice}} </strong></p>
                    <p *ngIf="duration.discount" class="mb-0 help-cta text-end" [class.opacity-75]="waitSave" [innerHTML]="duration.updatedDiscount"></p>
                </div>
            </mat-radio-button>
            <ng-container *ngIf="isOnboarding && order.is_automatic_renewal_available">
                <div *ngIf="duration.duration < ONBOARDING_AUTORENEWAL_FOR_DURATIONS" class="autorenewal-checkbox" [class.opened]="request.contract_duration?.duration && request.contract_duration.duration === duration.duration">
                    <div class="d-flex justify-content-between align-items-center pb-4 px-2">
                        <mat-checkbox [(ngModel)]="request.automatic_renewal" formControlName="automatic_renewal" class="text-truncate" [disabled]="waitSave">
                            {{"subscription-renewal-payment-checkbox-text" | translate}}
                        </mat-checkbox>
                        <div #tooltip="matTooltip" [matTooltip]="'subscription-renewal-payment-onboarding-tooltip' | translate" matTooltipPosition="above">
                            <div class="icp-icon-32 icp-info-tooltip pt-2"></div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </mat-radio-group>
</form>
<button [disabled]="waitSave || !contractSelectionForm.valid" class="btn btn-primary mt-5 mb-3 w-100" (click)="contractSelection()">
    <span>{{"order-detail-vehicle-info-action-confirm" | translate}}</span>
    <div *ngIf="waitSave" class="spinner-border ms-2"></div>
</button>